import { useState } from 'react';
import { saveRecommendation, deleteRecommendation as deleteRec } from '../../api';

const EMPTY = { sectionId: '', sectionName: '', recommendationText: '', riskRatingCode: '', riskFrom: '', riskTo: '', timescale: '', actionComplete: '', completedBy: '' };

export default function RecommendationsTab({ report, sections, riskRatings, onSave, readOnly = false }) {
  const [items] = useState(report.recommendations || []);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [msg, setMsg] = useState('');

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const startNew = () => { setEditing('new'); setForm({ ...EMPTY, sectionId: sections[0]?.id || '' }); };
  const startEdit = (item) => { setEditing(item.id); setForm({ ...item }); };
  const cancel = () => { setEditing(null); setForm(EMPTY); };

  const handleSave = async () => {
    try {
      await saveRecommendation(report.id, {
        ...form,
        id: editing === 'new' ? null : editing,
        sectionId: Number(form.sectionId),
        sortOrder: items.length,
      });
      setMsg('Saved');
      setEditing(null);
      setForm(EMPTY);
      onSave();
      setTimeout(() => setMsg(''), 2000);
    } catch (err) { setMsg(err.message); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this recommendation?')) return;
    await deleteRec(id);
    onSave();
  };

  return (
    <div>
      {msg && <div className="alert alert-success">{msg}</div>}
      {!readOnly && <button className="btn btn-primary" onClick={startNew} style={{ marginBottom: '1rem' }}>Add Recommendation</button>}

      {!readOnly && editing && (
        <div style={{ border: '1px solid #ddd', borderRadius: 6, padding: '1rem', marginBottom: '1rem', background: '#fafafa' }}>
          <div className="form-row">
            <div className="form-group">
              <label>Section</label>
              <select name="sectionId" value={form.sectionId} onChange={handleChange}>
                {sections.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Section Name</label><input name="sectionName" value={form.sectionName} onChange={handleChange} placeholder="e.g. Logbook System" /></div>
          </div>
          <div className="form-group"><label>Recommendation</label><textarea name="recommendationText" rows={3} value={form.recommendationText} onChange={handleChange} style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: 6, fontFamily: 'inherit' }} /></div>
          <div className="form-row">
            <div className="form-group">
              <label>Rating</label>
              <select name="riskRatingCode" value={form.riskRatingCode} onChange={handleChange}>
                <option value="">—</option>
                {riskRatings.map((r) => <option key={r.code} value={r.code}>{r.code}</option>)}
              </select>
            </div>
            <div className="form-group"><label>From</label><select name="riskFrom" value={form.riskFrom} onChange={handleChange}><option value="">—</option>{riskRatings.map((r) => <option key={r.code} value={r.code}>{r.code}</option>)}</select></div>
            <div className="form-group"><label>To</label><select name="riskTo" value={form.riskTo} onChange={handleChange}><option value="">—</option>{riskRatings.map((r) => <option key={r.code} value={r.code}>{r.code}</option>)}</select></div>
            <div className="form-group"><label>Timescale</label><input name="timescale" value={form.timescale} onChange={handleChange} placeholder="Immediate" /></div>
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button className="btn btn-primary" onClick={handleSave}>Save</button>
            <button className="btn btn-outline" style={{ color: '#333', borderColor: '#ccc' }} onClick={cancel}>Cancel</button>
          </div>
        </div>
      )}

      <div className="table-scroll">
        <table className="data-table">
          <thead><tr><th>Section</th><th>Recommendation</th><th>Rating</th><th>Risk</th><th>Timescale</th>{!readOnly && <th></th>}</tr></thead>
          <tbody>
            {(report.recommendations || []).map((r) => (
              <tr key={r.id}>
                <td style={{ fontSize: '0.8rem' }}>{r.sectionName}</td>
                <td style={{ fontSize: '0.8rem' }}>{r.recommendationText?.substring(0, 80)}...</td>
                <td>{r.riskRatingCode}</td>
                <td style={{ fontSize: '0.8rem' }}>{r.riskFrom} &gt; {r.riskTo}</td>
                <td>{r.timescale}</td>
                {!readOnly && <td>
                  <button onClick={() => startEdit(r)} style={{ cursor: 'pointer', border: 'none', background: 'none', color: '#4361ee' }}>Edit</button>
                  <button onClick={() => handleDelete(r.id)} style={{ cursor: 'pointer', border: 'none', background: 'none', color: '#dc2626', marginLeft: 8 }}>Del</button>
                </td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
